import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface INumberOfBedrooms {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  noBedroom?: number | null;
  oneBedroom?: number | null;
  twoBedrooms?: number | null;
  threeBedrooms?: number | null;
  fourBedrooms?: number | null;
  fiveOrMoreBedrooms?: number | null;
}

export const defaultValue: Readonly<INumberOfBedrooms> = {};
